import { render, staticRenderFns } from "./LoadingReintegroDettaglio.vue?vue&type=template&id=0d54ca05"
import script from "./LoadingReintegroDettaglio.vue?vue&type=script&lang=ts"
export * from "./LoadingReintegroDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d54ca05')) {
      api.createRecord('0d54ca05', component.options)
    } else {
      api.reload('0d54ca05', component.options)
    }
    module.hot.accept("./LoadingReintegroDettaglio.vue?vue&type=template&id=0d54ca05", function () {
      api.rerender('0d54ca05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingReintegroDettaglio.vue"
export default component.exports